import { LitElement, html } from 'lit';

class CollectionFilter extends LitElement {

  static properties = {
    collection_list: { type: Array },
    selected_collection: { type: String },
    storage_key: { type: String },
    jsonId: { type: String, attribute: 'json-id' }
  };

  constructor() {
    super();
    this.collection_list = [];
    this.selected_collection = '';
    this.storage_key = ''; 
    this.jsonId = ''; 
  }

  createRenderRoot() { return this; }

  select_collection(handle, isInitialLoad = false) {
    this.selected_collection = handle;
    const images = document.querySelectorAll('.collection_card_image_wrapper img');
    images.forEach(img => img.classList.add('blurred'));
    
    if (!isInitialLoad && window.innerWidth <= 768) {
      const cardsContainer = document.querySelector('.collection_cards');
      if (cardsContainer) {
        const headerOffset = 100;
        const elementPosition = cardsContainer.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }

    setTimeout(() => {
      images.forEach(img => img.classList.remove('blurred'));
    }, 400);
    
    this.dispatchEvent(new CustomEvent('collection_changed', {
      detail: { collection: handle },
      bubbles: true,
      composed: true
    }));
    this.requestUpdate();
  }
  
  firstUpdated() {
    const jsonScript = document.getElementById(this.jsonId);
    if (!jsonScript) {
      console.warn(`No JSON script found with id "${this.jsonId}".`);
      return;
    }

    try {
      const parsed = JSON.parse(jsonScript.textContent);
      const collections = parsed?.collections || [];

      if (!collections.length) return;

      this.collection_list = collections;

      const firstHandle = collections[0]?.handle;
      if (firstHandle) {
        this.selected_collection = firstHandle;
        requestAnimationFrame(() => this.select_collection(firstHandle, true));
      }
    } catch (err) {
      console.error('Error parsing collection JSON:', err);
    }
  }
  

  render() {
    return html`
      <div class="collection_filter">
        ${this.collection_list.map(c => html`
          <button
            class="${c.handle === this.selected_collection ? 'active' : ''}"
            @click=${() => this.select_collection(c.handle, false)}
          >
            ${c.label}
          </button>
        `)}
      </div>
    `;
  }
}

customElements.define('collection-filter', CollectionFilter);
